import React, { createContext, useContext, useState, useEffect } from 'react';
import logger from '../utils/logger';

const AuthContext = createContext(null);

/** Convert legacy string format ("leads", "both") to array (["leads"], ["leads","sales"]). */
function normalizeModules(val) {
  if (Array.isArray(val)) return val;
  if (val === 'both') return ['leads', 'sales'];
  if (typeof val === 'string' && val) return [val];
  return [];
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(() => localStorage.getItem('token'));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (token) {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        setUser({
          id: payload.sub,
          email: payload.email,
          role: payload.role,
          tenantId: payload.tenant_id,
          tenantName: payload.tenant_name,
          name: payload.name,
          assignedModules: normalizeModules(payload.assigned_modules),
        });
      } catch {
        logger.warn('auth', 'Invalid token in localStorage, clearing');
        localStorage.removeItem('token');
        setToken(null);
      }
    }
    setLoading(false);
  }, [token]);

  const login = (newToken) => {
    localStorage.setItem('token', newToken);
    setToken(newToken);
    logger.info('auth', 'User logged in');
  };

  const logout = () => {
    logger.info('auth', 'User logged out');
    localStorage.removeItem('token');
    setToken(null);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, token, login, logout, loading, isAuthenticated: !!token }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
}
